


export const removeWishList = async (product_id) => {
    const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_remove_wish_list&product_id=${product_id}&nonce=${wcProducts?.nonce}`);
    const response = await res.json();
    return response;
}

export const showWishList = async () => {
    const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_all_wish_list&nonce=${wcProducts?.nonce}`);
    const response = await res.json();
    return response;
}

export const addWishList = async (product_id) => {
    const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_add_wishlist&product_id=${product_id}&nonce=${wcProducts?.nonce}`);
    const response = await res.json();
    return response;
}

export const fetchCartProducts = async () => {
    const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_cart_products&nonce=${wcProducts?.nonce}`);
    const response = await res.json();
    return response;
}

export const addToCart = async (productId, quantity = 1, setProductLoading) => {
    setProductLoading(productId, true);
    try {
        const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_add_to_cart&product_id=${productId}&quantity=${quantity}&nonce=${wcProducts?.nonce}`);
        const response = await res.json();
        return response;
    } catch (error) {
        console.error('Error adding to cart:', error);
        throw error;
    } finally {
        setProductLoading(productId, false);
    }
}


export const getProducts = async (categories, limit = -1, order_by, order) => {
    console.log(categories);
    const res = await fetch(`${wcProducts?.ajaxUrl}?action=bpswb_get_products&categories=${categories}&limit=${limit}&order_by=${order_by}&order=${order}&nonce=${wcProducts?.nonce}`);
    const response = await res.json();
    return response;
}

